export const AUTH_TOO_MANY_REQUESTS_MESSAGE =
  'Une activité inhabituelle a été détectée. Vous avez effectué trop de requêtes dans un court laps de temps. Veuillez réessayer ultérieurement.';